import * as React from "react";
import type { SVGProps } from "react";
const SvgUmbrella01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M11.2 13.2v5.2a2.8 2.8 0 1 0 5.6 0V18m4.8-5.6H2.4a9.6 9.6 0 1 1 19.2 0"
    />
  </svg>
);
export default SvgUmbrella01;
